/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import Timeline from '../../share/TopicsMode/Timeline'
import TopicsModeWidgetDataGuards from '../../share/TopicsMode/guards/TopicsModeWidgetDataGuards'
import { WidgetLoadingGuard } from '../../../share/guards'
import WidgetSettingGuards from './guards/WidgetSettingGuards'
import RunSearchEffect from './searches/RunSearchEffect'

const YouTubeTimelineWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <WidgetSettingGuards widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <TopicsModeWidgetDataGuards widgetId={widgetId}>
            <Timeline widgetId={widgetId} />
          </TopicsModeWidgetDataGuards>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </WidgetSettingGuards>
  </UnexpectedErrorBoundary>
)

export default YouTubeTimelineWidget
